export type StatusTone = 'neutral' | 'info' | 'warning' | 'error' | 'success';

export const STATUS_CONFIG: Record<string, StatusTone> = {
	Open: 'warning',
	Created: 'warning',
	Validated: 'warning',
	Reopened: 'warning',

	PubliclyLeaked: 'error',

	Fixed: 'success',
	Resolved: 'success',
	ClosedByUser: 'success',

	Dismissed: 'neutral',
	AutoDismissed: 'neutral',
	Unknown: 'neutral',
};

export const INTERNAL_STATUS_CONFIG: Record<string, StatusTone> = {
	'To Do': 'neutral',
	'In Progress': 'info',
	Blocked: 'error',
	Done: 'success',
	Unknown: 'neutral',
};

export const SEVERITY_OPTIONS = ['Critical', 'High', 'Medium', 'Low'] as const;
export const ALERT_TYPE_OPTIONS = [
	'Dependabot',
	'CodeQL',
	'Code Scanning',
	'Secret Scanning',
	'Sheet Import',
	'Sarif',
] as const;

export const SEARCH_DEBOUNCE_MS = 300;
export const DEFAULT_PAGE_SIZE = 25;
export const PAGE_SIZE_OPTIONS = [10, 25, 50, 100];
export const MAX_PAGE_SIZE = 100;
